
import { REQUEST_PLANS, REQUEST_PLANS_ERROR, RECEIVE_PLANS } from 'actions'

const initialState = {
  isRequesting: false,
  didRequestFail: false,
  didRequest: false,
  error: null,
  data: []
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_PLANS:
      return {
        ...state,
        isRequesting: true,
        didRequestFail: false,
        error: null
      }
    case REQUEST_PLANS_ERROR:
      return {
        ...state,
        isRequesting: false,
        didRequest: true,
        didRequestFail: true,
        error: payload
      }
    case RECEIVE_PLANS:
      return {
        ...state,
        isRequesting: false,
        didRequest: true,
        didRequestFail: false,
        data: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/plans.js